import React from "react";

const Footer = () => {
  return (
    <section
      className="section"
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <p>Developed by - @CR (Chillukala Rakesh) - {new Date().getFullYear()}</p>
    </section>
  );
};

export default Footer;
